// local lib
import generateColumn from '../lib/generateColumn.lib';

export default generateColumn({
  key: 'completeness',
  title: 'Coverage',
  align: 'center',
  width: '140px',
});
